(() => {
  const update = () => {
    const displayMode = window.swinger.user.getDisplayMode();
    document.documentElement.classList.remove('scheme-auto', 'scheme-dark', 'scheme-light');
    document.documentElement.classList.add(`scheme-${displayMode}`);
  };
  update();
  document.addEventListener('swinger.user:authchange', update);
})();
